import { IMPRESSION_ACTIONS, SCREEN_NAME } from "@payment-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

//impression event
export const offerStripImpressionEvent = (
    offerText: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        label: offerText,
        action: IMPRESSION_ACTIONS.IMPRESSION_PAYMENT_OFFER_STRIP,
    });
};
